module.exports = __webpack_public_path__ + "media/lymphoid follicles.6efd7059.wav";